<template>
	<AlertCardWrapper :titleArr="titleArr" :alert="alert">
		<template #action>
			<ActionButton :title="actionTitle" @action-button-click="actionButtonClick" />
		</template>
		<template #subtitle>
			<SubTitle :hideIcon="hideIcon" :text="subtitleText" :icon="subtitleIcon" />
		</template>
	</AlertCardWrapper>
</template>

<script>
import AlertTypeBaseMixin from '../mixins/AlertTypeBaseMixin';
export default {
	name: 'ModuleSharedRequiresSetup',
	mixins: [AlertTypeBaseMixin],
	computed: {
		titleArr() {
			return [{ text: this.sharingUserName, isBold: true }, { text: 'has shared a feature with you, it requires set up' }];
		},
		actionTitle() {
			return 'Setup';
		},
		subtitleText() {
			return `[Feature Name / FeatureType], Shared by ${this.sharingUserName}`;
		},
		subtitleIcon() {
			return 'shopify'; // TODO - this should return modules context icon
		},
		sharingUserName() {
			return '[Sharing User]';
		},
	},
	methods: {
		actionButtonClick() {
			console.log('ModuleSharedRequiresSetup clicked');
		},
	},
};
</script>
<style lang="scss" scoped></style>
